// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import paths from "../../routes/paths";
// import logo from "../../assets/images/asteria/asteria_logo.png";

// function Header() {
//     const [showMenu, setShowMenu] = useState(false)
//     return (
//         <nav className="container w-full bg-base-100 text-base-content p-2">
//             <div class="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
//                 <div className="flex items-center">
//                     <Link to={paths.home} className="btn btn-ghost normal-case"><img src={logo} width={96} height={52} /></Link>
//                 </div>
//                 <div className="block lg:hidden">
//                     <button onClick={() => setShowMenu(!showMenu)} id="nav-toggle" className="flex items-center p-1  focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">
//                         <svg className="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
//                             <title>Menu</title>
//                             <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
//                         </svg>
//                     </button>
//                 </div>
//                 <div className={`w-full flex-grow lg:flex lg:items-center lg:w-auto ${showMenu ? 'flex' : 'hidden'}  mt-2 lg:mt-0  p-4 lg:p-0 z-20`} id="nav-content">
//                     <ul className="list-reset lg:flex justify-end flex-1 items-center">
//                         <li className="p-2 tracking-wider"><Link to={paths.home}>Home</Link></li>
//                         <li className="p-2 tracking-wider"><a href="https://theasteria.shop/">Shop</a></li>
//                         <li className="p-2 tracking-wider"><Link to={paths.about}>About</Link></li>
//                         <li className="p-2 tracking-wider"><Link to={paths.portfolio}>Portfolio</Link></li>
//                         <li className="p-2 tracking-wider"><Link to={paths.contact}>Contact</Link></li>
//                     </ul>
//                 </div>
//             </div>
//         </nav>
//     );
// }

// export default Header;

import React from "react";
import { useDisclosure } from "@mantine/hooks";
import { Tooltip, Menu, Button } from "@mantine/core";
import { TbHome2, TbInfoCircle, TbPhoneCalling } from "react-icons/tb";
import { MdOutlinePeopleAlt, MdOutlineShoppingBag } from "react-icons/md";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import logo from "../../assets/images/asteria/asteria_logo.png";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

const Header = () => {
  const [opened, { toggle }] = useDisclosure(false);
  const label = opened ? "Close navigation" : "Open navigation";
  return (
    <nav className="navbar bg-transparent">
      <div className="navbar-start">
        <Menu shadow="md" width={200} position="bottom-start">
          <Menu.Target>
            <button
              className="bg-transparent text-xl shadow-lg p-2 rounded-lg hover:scale-105 transition"
            >
              <HiOutlineMenuAlt2 className="text-[#D8AE96]" />
            </button>
          </Menu.Target>

          <Menu.Dropdown>
            <Link to={paths.home}>
              <Menu.Item icon={<TbHome2 size={14} />}>Home</Menu.Item>
            </Link>
            <Link to={paths.portfolio}>
              <Menu.Item icon={<MdOutlinePeopleAlt size={14} />}>
                Portfolio
              </Menu.Item>
            </Link>
            <Link to={paths.about}>
              <Menu.Item icon={<TbInfoCircle size={14} />}>About</Menu.Item>
            </Link>
            <Link to={paths.contact}>
              <Menu.Item icon={<TbPhoneCalling size={14} />}>Contact</Menu.Item>
            </Link>
          </Menu.Dropdown>
        </Menu>
      </div>
      <div className="navbar-center">
        <button
          className="border-none"
        >
          <img src={logo} alt="" className="w-16" />
        </button>
      </div>
      <div className="navbar-end">
        {/* <Tooltip label="Shop now">
          <a href="https://theasteria.shop/shop">
            <button
              className="bg-transparent border text-xl shadow-lg p-2 rounded-lg"
            >
              <MdOutlineShoppingBag className="text-[#D8AE96]" />
            </button>
          </a>
        </Tooltip> */}
      </div>
    </nav>
  );
};

export default Header;
